export default __webpack_public_path__ + "se-quoia-complete-visual.svg";